import moment from 'moment-timezone'

export default ({ event: { timestamp } }) =>
  moment(timestamp).isBefore(moment().subtract(1, 'hour'))
